import React from 'react';
import { LightboxProvider, LightboxImageTrigger } from "@/modern/components/ui/lightbox";

interface ImageData {
  src: string;
  alt: string;
  caption?: string;
}

interface SpotIncentiveImagePreviewProps {
  images: ImageData[];
  children: React.ReactNode;
  allowZoom?: boolean;
}

const SpotIncentiveImagePreview: React.FC<SpotIncentiveImagePreviewProps> = ({
  images,
  children,
  allowZoom = true
}) => {
  return (
    <LightboxProvider
      images={images}
      allowZoom={allowZoom}
    >
      {children}
    </LightboxProvider>
  );
};

interface ImageThumbnailProps {
  src: string;
  alt: string;
  index: number;
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
}

export const ImageThumbnail: React.FC<ImageThumbnailProps> = ({
  src,
  alt,
  index,
  className = "w-16 h-16 rounded overflow-hidden bg-muted flex-shrink-0 cursor-pointer hover:opacity-80 transition-opacity",
  onClick
}) => {
  return (
    <LightboxImageTrigger index={index}>
      <div
        className={className}
        onClick={onClick}
      >
        <img
          src={src}
          alt={alt}
          className="w-full h-full object-cover"
        />
      </div>
    </LightboxImageTrigger>
  );
};

export default SpotIncentiveImagePreview;
